export const featureFlags = {
  optionCOperateV2: false,
  optionCManageV2: false,
  optionCAnalyzeV2: false,
  optionCAdminV2: false,
  optionCToolsV2: false,
};

export const isFeatureEnabled = (flagName) => Boolean(featureFlags[flagName]);
